<script setup lang="ts">
const carousels = [
  {
    title: 'Penuhi Syarat COD Advance',
    description:
      'Jika riwayat nilai barang COD, jumlah paket COD, dan tingkat retur paketmu memenuhi syarat, kamu dapat mengajukan COD Advance.'
  },
  {
    title: 'Ajukan COD Advance',
    description:
      'Tentukan nominal pengajuan COD Advance-mu dalam rentang nilai COD yang dapat dicairkan.'
  },
  {
    title: 'COD Advance Masuk Rekening',
    description:
      'Nominal yang kamu ajukan akan ditransfer ke rekening sesuai dengan ketentuan pencairan COD Advance.'
  },
  {
    title: 'Penyelesaian Otomatis',
    description:
      'Setiap dana COD yang masuk ke saldo aktif berikutnya, akan secara otomatis digunakan untuk mengganti dana COD Advance yang sudah kamu cairkan.'
  }
]
</script>

<template>
  <div class="bg-surface-container-low py-7 lg:py-16 relative overflow-hidden">
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-11 relative z-10">
      <UiSectionTitle
        class="text-center"
        title="Cara Kerja COD Advance"
        description="COD Advance adalah solusi percepatan pencairan nilai barang COD saat paketmu masih dalam perjalanan, untuk lancarkan arus kas bisnismu."
      />
      <UiCarouselFeature :items="carousels" />
    </UiContainer>
  </div>
</template>
